import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12.3004",
      cy: "7.11879",
      r: "4.74965",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.1028 23.609V19.4927C21.1028 17.2835 19.3119 15.4927 17.1028 15.4927H12.3033H7.50391C5.29477 15.4927 3.50391 17.2835 3.50391 19.4927V23.609",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }